// Serviço para consulta de CEP usando ViaCEP
export const cepService = {
  // Buscar endereço por CEP
  async getAddressByCep(cep) {
    try {
      // Limpar CEP (remover caracteres não numéricos)
      const cleanCep = cep.replace(/[^\d]/g, '');
      
      // Validar formato do CEP
      if (cleanCep.length !== 8) {
        throw new Error('CEP deve ter 8 dígitos');
      }
      
      // Validar se não é um CEP inválido conhecido
      if (/^0{8}$/.test(cleanCep)) {
        throw new Error('CEP inválido');
      }
      
      // Fazer requisição para ViaCEP
      const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
      
      if (!response.ok) {
        throw new Error('Erro ao consultar CEP');
      }
      
      const data = await response.json();
      
      // Verificar se o CEP foi encontrado
      if (data.erro) {
        throw new Error('CEP não encontrado');
      }
      
      // Retornar dados formatados
      return {
        cep: data.cep,
        logradouro: data.logradouro || '',
        complemento: data.complemento || '',
        bairro: data.bairro || '',
        localidade: data.localidade || '', // cidade
        uf: data.uf || '', // estado
        ibge: data.ibge || '',
        gia: data.gia || '',
        ddd: data.ddd || '',
        siafi: data.siafi || '',
        // Campos formatados para facilitar o uso
        endereco: data.logradouro || '',
        cidade: data.localidade || '',
        estado: data.uf || ''
      };
    } catch (error) {
      // Re-lançar erro com mensagem mais amigável
      if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
        throw new Error('Erro de conexão. Verifique sua internet e tente novamente.');
      }
      
      throw error;
    }
  },
  
  // Formatar CEP para exibição (xxxxx-xxx)
  formatCep(cep) {
    const cleanCep = cep.replace(/[^\d]/g, '');
    
    if (cleanCep.length === 8) {
      return `${cleanCep.slice(0, 5)}-${cleanCep.slice(5)}`;
    }
    
    return cleanCep;
  },
  
  // Validar CEP
  isValidCep(cep) {
    const cleanCep = cep.replace(/[^\d]/g, '');
    return cleanCep.length === 8 && !/^0{8}$/.test(cleanCep);
  }
};
